module.exports = __webpack_public_path__ + "img/icon_shangchuanS.74fd08c6.svg";